/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import queryString from "query-string";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";

import environment from "constants/apiConst";
import TableOrder from "components/Tables/TableOrder";
import ConfigurationHeader from "../ConfigurationHeader";
import Pagination from "components/Pagination/Pagination";
import VehicularDoorForm from "../forms/VehicularDoorForm";
import TbodyVehicularDoor from "../tables/TbodyVehicularDoor";
import { FormShowVheicularDoor } from "../FormShow/FormVehiculaDoor";
import { SectionContainerGene } from "styled/SectionContainer.styled";
import { __VehicularDoor } from "request/configuration/__VehicularDoor";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { useGlobalContext } from "context/GlobalContext";
import { useQuery } from "@tanstack/react-query";

const VehicularDoor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState([]);
  const { q = "" } = queryString.parse(location.search);
  const freeZone_id = useSelector((state) => state.auth.dataUser.token);
    const {
    update,
    setFormEdit,
    setFormShow,
    setRequestEdit,
    setRequestCreate,
    setRequestDelete
  } = useContext(ConfigurationCRUDContext);

  const thead = [
    { name: "Nombre", order: "name_vehicularDoor" },
    { name: "Tipo", order: "type_vehicularDoor" },
    { name: "Estado", order: "status_vehicularDoor" },
    { name: "Acciones", order: "actions_vehicularDoor" }
  ];

  const formEdit = () => {
    return <VehicularDoorForm />;
  };

  const formShow = () => {
    return <FormShowVheicularDoor />;
  };

  useEffect(() => {
    setFormEdit(formEdit);
    setFormShow(formShow);
    setRequestEdit(environment.VEHICULAR_DOOR_UPDATE);
    setRequestCreate(environment.VEHICULAR_DOOR_CREATE);
    setRequestDelete(environment.VEHICULAR_DOOR_DELETE);
  }, [page, q, update]);

  const { requestData } = useGlobalContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["configVehicularDoor", page, q, freeZone_id, update],
    queryFn: () => requestData({
      Endpoint: environment.VEHICULAR_DOOR_GET,
      pageParam: page,
      ...(q?.length !== 0 && { data: { search: q } }),
      PropertyBody: "sendJSONContentPOST",
    })
  })

  useEffect(() => {
    if (data?.data?.status?.code !== 200) return;
    if (data?.data?.status?.data?.last_page < page) setPage(1);
  }, [data?.data?.status?.data?.last_page])

  return (
    <SectionContainerGene>
      <ConfigurationHeader title="Puertas Vehiculares"></ConfigurationHeader>
      {isLoading || (
        <TableOrder
          thead={thead}
          data={data?.data?.status?.code === 200 ? data?.data?.status?.data?.data : []}
          setData={setCurrentPage}
          loading={isLoading}
          tbodyData={TbodyVehicularDoor}
        />
      )}
      <Pagination
        thead={thead}
        page={page}
        setPage={setPage}
        maxPage={data?.data?.status?.code === 200 ? data?.data?.status?.data?.last_page : 1}
        loading={isLoading}
      />
    </SectionContainerGene>
  );
};

export default VehicularDoor;
